module.exports = __webpack_public_path__ + "static/media/5.92f3159b.jpeg";